import { LocationType } from '../../../../types/location';
const onlyDigits = (value) => value.replace(/\D/g, '');
export function mapEmissorContractAddressItemToAddress(address) {
    if (!address) {
        return undefined;
    }
    return {
        locationId: address.id,
        locationType: LocationType.COMMERCIAL,
        address: address.street,
        addressLine2: address.neighborhood,
        number: address.number,
        complement: address.complement ?? '',
        zipCode: address.postalCode,
        city: address.city,
        state: address.state,
        country: 'Brasil',
        name: address.name ?? '',
    };
}
export function mapAddressToUpdateContractAddressBody(address) {
    return mapAddressToCreateContractAddressBody(address);
}
export function mapAddressToCreateContractAddressBody(address) {
    return {
        name: address.name ?? '',
        street: address.address,
        number: address.number,
        neighborhood: address.addressLine2 ?? '',
        postalCode: onlyDigits(address.zipCode),
        city: address.city,
        state: address.state,
        complement: address.complement ?? null,
    };
}
